import { TRANSACTION_LOADING, GET_TRANSACTION, GET_TRANSACTION_SUCCESS, GET_TRANSACTION_FAIL, ADD_TRANSACTION_SUCCESS, ADD_TRANSACTION_FAIL, DELETE_TRANSACTION_SUCCESS, DELETE_TRANSACTION_FAIL, UPDATE_TRANSACTION_SUCCESS, UPDATE_TRANSACTION_FAIL, TRANSACTION_RESET, TRANSACTION_RESET_CREATE, GET_TRANSACTION_ONE } from "./actionType";

const INIT_STATE = {
  transactions: [],
  transactionOne: null,
  transactionAdded: {},
  error: {},
};

const Transaction = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TRANSACTION_SUCCESS:
      switch (action.payload.actionType) {
        case GET_TRANSACTION:
          return {
            ...state,
            transactions: action.payload.data,
            isTransactionCreated: false,
            isTransactionSuccess: true,
            loading: false,
          };

        case GET_TRANSACTION_ONE:
          return {
            ...state,
            transactionOne: action.payload.data,
            isTransactionSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_TRANSACTION_FAIL:
      switch (action.payload.actionType) {
        case GET_TRANSACTION_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isTransactionCreated: false,
            isTransactionSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_TRANSACTION: {
      return {
        ...state,
        isTransactionCreated: false,
        loading: true,
      };
    }

    case GET_TRANSACTION_ONE: {
      return {
        ...state,
        transactionOne: action.payload.data,
        isTransactionCreated: false,
        loading: true,
      };
    }

    case TRANSACTION_LOADING: {
      return {
        ...state,
        isTransactionCreated: false,
        loading: true,
      };
    }

    case ADD_TRANSACTION_SUCCESS:
      return {
        ...state,
        isTransactionCreated: true,
        loading: false,
        transactions: [action.payload.data, ...state.transactions],
        transactionAdded: action.payload.data,
      };

    case ADD_TRANSACTION_FAIL:
      return {
        ...state,
        isTransactionCreated: false,
        loading: false,
        error: action.payload,
      };

    case DELETE_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        transactions: state.transactions.filter((transaction) => transaction.id.toString() !== action.payload.id.toString()),
      };

    case DELETE_TRANSACTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        isTransactionCreated: true,
        transactions: state.transactions.map((transaction) => (transaction.id.toString() === action.payload.data.id.toString() ? { ...transaction, ...action.payload.data } : transaction)),
        transactionAdded: action.payload.data,
      };

    case UPDATE_TRANSACTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case TRANSACTION_RESET_CREATE:
      return {
        ...state,
        isTransactionCreated: false,
      };

    case TRANSACTION_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Transaction;
